import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/carboncraft.webp';
import screenshot_target from '../../../images/letterfunnel/paulbuyse.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Paul Buyse"
      firstname="Paul"
      companyname="Carboncraft"
      competition="Xquip en Tec Wire"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/paulbuyse.js